<template>
    <Menu :model="model" :popup="popup" ref="menuRef" :pt="{
        root: { class: 'p-menu-overlay' },
        menu: { class: 'p-menu p-component' },
        list: { class: 'p-menu-list p-reset' },
        menuitem: { class: 'p-menuitem' },
        content: { class: 'p-menuitem-content' },
        action: { class: 'p-menuitem-link' },
        icon: { class: 'p-menuitem-icon' },
        label: { class: 'p-menuitem-text' },
        separator: { class: 'p-menuitem-separator' }
    }" />
</template>

<script setup lang="ts">
import Menu from 'primevue/menu';
import type { MenuProps } from '../../../../types/menu';
import { ref } from 'vue';

const props = withDefaults(defineProps<MenuProps>(), {
    popup: false,
    model: () => [],
    exact: true
});

const menuRef = ref();

const toggle = (event: Event) => {
    menuRef.value?.toggle(event);
};

const show = (event: Event) => {
    menuRef.value?.show(event);
};

const hide = () => {
    menuRef.value?.hide();
};

defineExpose({
    toggle,
    show,
    hide
});
</script>
